import { Component } from 'react'

// Last-resort catch for render errors so a bad state renders a recovery path
// instead of a blank page.
//
// Pass `resetKey` (the current route) to clear a caught error on navigation —
// without it, one bad render leaves every route dead until a full page reload.
// Implemented as a state reset rather than a `key` on the boundary, so that while
// no error is present this costs nothing and never remounts the subtree.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null })
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6 max-w-xl mx-auto text-center py-20">
          <h1 className="text-xl font-bold mb-2">Something went wrong</h1>
          <p className="text-sm opacity-60 mb-6">{this.state.error.message}</p>
          <button className="btn btn-sm btn-primary" onClick={() => window.location.assign('/')}>
            Reload
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
